import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../TimeModal/TimeModalContext';
import { formatDateTime, isWithinLastHalfHour } from '../../Utils/GlobalUtils';

import Loading from '../Loading';

import styles from '../../styles/DynamicModal.module.css';

const CommentsCase = ({ caseId, access, onCommentsSuccess, sideReload }) => {
    const { openTimeModal } = useTimeModal();

    const [comments, setComments] = React.useState([]);
    const [newComment, setNewComment] = React.useState('');
    const [commentsNull, setCommentsNull] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [warning, setWarning] = React.useState('');
    const [reload, setReload] = React.useState(true);

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get(`/api/get-comments?caseId=${caseId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
        })
        .then(response => {
            if (response.data.length === 0) {
                setCommentsNull('Комментарии отсутствуют');
                setComments([]);
            } else {
                setCommentsNull('');
                setWarning('');
                setComments(response.data);
            }
        })
        .catch(error => {
            setWarning(`Ошибка при загрузке комментариев:  ${error.response?.data.message || error.message}`);
            setComments([]);
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
        })
    }, [reload, caseId, sideReload]);


    const [confirmDelete, setConfirmDelete] = React.useState(null);
    const deleteComment = (commentId) => {
        axios.delete(`/api/delete-comment?commentId=${commentId}`)
        .then(() => {
            onCommentsSuccess();
        })
        .catch(() => {
            openTimeModal('Ошибка при удалении комментария', 'error');
        })
        .finally(() => {
            setReload(true);
        });
    };
    const handleDeleteCommentClick = (commentId) => {
        if (confirmDelete === commentId) {
            deleteComment(commentId);
            setConfirmDelete(null);
        } else {
            setConfirmDelete(commentId);
        }
        setTimeout(() => {
            setConfirmDelete(null);
        }, 2000);
    };

    const [confirmChange, setConfirmChange] = React.useState(null);
    const [selectedCommentId, setSelectedCommentId] = React.useState('');
    const changeComment = () => {
        axios.put(`/api/change-comment?commentId=${selectedCommentId}&newComment=${newComment}`)
        .then(() => {
            onCommentsSuccess();
        })
        .catch(() => {
            openTimeModal('Ошибка при изменении комментария', 'error');
        })
        .finally(() => {
            setConfirmChange(null);
            setReload(true);
        });
    };
    const handleChangeCommentClick = (commentId, comment) => {
        setConfirmChange(commentId);
        setNewComment(comment);
        setSelectedCommentId(commentId);
    };

    return (
        loading ? <Loading />
        : warning ? <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{warning}</a>
        : commentsNull ? <a style={{color: 'rgb(169, 169, 169)'}}>{commentsNull}</a>
        : comments.map((comment) => (
                confirmChange !== comment.id ? (
                <div className={styles.caseComponentLine} key={comment.id}>
                    <span>
                        <a>{comment.comment}</a>
                        {access && comment.mailing_status=='Письмо отправлено' && <a className={styles.time}>Арбитражный управляющий оповещен об этом комментарии по email</a>}
                        <a className={styles.time}>{formatDateTime(comment.created_at)}</a>
                    </span>
                    <div className={styles.commentActions}>
                        {confirmDelete === comment.id ? (
                            <button 
                                className="button miniButton" 
                                style={{fontSize: '12px', margin: '0 0 0 10px'}}
                                onClick={() => handleDeleteCommentClick(comment.id)}
                            >
                                Удалить?
                            </button>
                        ) : (
                            <>
                                {(access || isWithinLastHalfHour(comment.created_at)) && (
                                    <>
                                        <img src='/img/icons/pen.svg' alt='Изменить' title='Изменить' onClick={() => handleChangeCommentClick(comment.id, comment.comment)} />
                                        <img src='/img/icons/trash.svg' alt='Удалить' title='Удалить' onClick={() => handleDeleteCommentClick(comment.id)} />
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </div>
                ) : (
                    <div style={{boxShadow: '0 0 0 1px #e5e5e5', padding: '10px', boxSizing: 'border-box', margin: '10px 0', borderRadius: '.5em'}}>
                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px'}}>
                            <h2 style={{margin: '0'}}>Измените комментарий</h2>
                            <img src='/img/icons/close-x.svg' alt='X' style={{width: '20px', cursor: 'pointer'}} onClick={() => handleChangeCommentClick(null)} />
                        </div>
                        <a>Введите комментарий</a>
                        <input type='text' value={newComment} onChange={(e) => setNewComment(e.target.value)} maxLength='200' placeholder='Комментарий' required />
                        <button type='button' className='button maxWidth' style={{marginTop: '10px'}} onClick={changeComment}>Изменить</button>
                    </div>
                )
            ))
    )
}

export default CommentsCase;